.j76a9j0 {
  display: grid;
  grid-auto-rows: min-content;
  max-width: 100%;
  width: 100%;
}